export const AVAILABLE_BRAND_PLURALS: [string, string, string] = [
  $localize`Бренд електромобілів`,
  $localize`Бренди електромобілів`,
  $localize`Брендів електромобілів`,
];

export const AVAILABLE_MODEL_PLURALS: [string, string, string] = [
  $localize`Комплектація на порталі`,
  $localize`Комплектації на порталі`,
  $localize`Комплектацій на порталі`,
];

export const AVAILABLE_OFFER_PLURALS: [string, string, string] = [
  $localize`Актуальна пропозиція`,
  $localize`Актуальні пропозиції`,
  $localize`Актуальних пропозицій`,
];

export const EV_PLURALS: [string, string, string] = [
  $localize`електромобіль`,
  $localize`електромобілі`,
  $localize`електромобілів`
];

export const SHOW_OFFER_PLURALS: [string, string, string] = [
  $localize`пропозицію`,
  $localize`пропозиції`,
  $localize`пропозицій`
];

export const REVIEW_PLURALS: [string, string, string] = [
  $localize`відгук`,
  $localize`відгуки`,
  $localize`відгуків`
];

export const RESULT_PLURALS: [string, string, string] = [
  $localize`результат`,
  $localize`результати`,
  $localize`результатів`
];
